<app-dialog>
  <app-dialog-title>{{
    (!selectedGroup ? 'SHARED.GROUPS.NEW_GROUP' : 'ACCOUNT.GROUPS.DIALOG.EDIT_GROUP_TITLE')
      | translate
  }}</app-dialog-title>
  <app-dialog-content>
    <p class="NewGroup__explainer">
      {{
        'ACCOUNT.GROUPS.DIALOG.GROUP_EXPLAINER'
          | translate: { childrenNamePlural: accountChildrenNamePlural }
      }}
    </p>
    <form [formGroup]="groupForm">
      <mat-form-field class="w-100">
        <mat-label>{{ 'SHARED.SYSTEM.NAME' | translate }}</mat-label>
        <input
          matInput
          autocomplete="off"
          list="autocompleteOff"
          required
          #nameInput
          name="name"
          formControlName="name"
          data-testid="input-group-name" />
        <mat-error appErrors="name" [errors]="errors" />
      </mat-form-field>
      <mat-form-field class="w-100 NewGroup__category mb-3">
        <mat-label>{{ 'SHARED.SYSTEM.CATEGORY' | translate }}</mat-label>
        <mat-select formControlName="categoryUuid" data-testid="select-category">
          @for (category of categories; track category.uuid) {
            <mat-option [value]="category.uuid">{{ category.name }}</mat-option>
          }
          <mat-option class="NewGroup__no-category" [value]="NO_CATEGORY_UUID">
            {{ 'SHARED.SYSTEM.NO_CATEGORY' | translate }}
          </mat-option>
        </mat-select>
        <mat-hint>{{ 'ACCOUNT.GROUPS.DIALOG.CATEGORY_OPTIONAL_HELP' | translate }}</mat-hint>
      </mat-form-field>
    </form>
  </app-dialog-content>
  <app-dialog-actions>
    <button matButton="outlined" type="button" class="me-1" matDialogClose data-testid="btn-cancel">
      {{ 'ACCOUNT.GROUPS.BUTTONS.CANCEL' | translate }}
    </button>
    <button matButton="filled" type="button" (click)="save()" data-testid="btn-save-group">
      {{
        (!selectedGroup ? 'ACCOUNT.GROUPS.DIALOG.CREATE_GROUP_BUTTON' : 'SHARED.SYSTEM.SAVE')
          | translate
      }}
    </button>
  </app-dialog-actions>
</app-dialog>
